const ViewChallengesBy = {
  TYPICAL: "typical",
  CATEGORY: "category",
  IMPORTANCE: "importance"
} as const;

const ALL = Object.values(ViewChallengesBy);

export default { ...ViewChallengesBy, ALL };
